module.exports = __webpack_public_path__ + "static/img/tabletmain-entry-img.4f51f303.svg";